<template>
  <div class="affair-container">
    <template v-if="viewType === 'list'">

      <search-box :status-list="statusList" ref="search" @change="research"></search-box>

      <div class="contentBox">
        <div class="contentTable">
          <el-table :data="tableData" size="medium">
            <el-table-column prop="flowNo" label="流程编号" width="180">
            </el-table-column>
            <el-table-column prop="typeName" label="类型" width="180">
            </el-table-column>
            <el-table-column prop="applyUserName" label="申请人"> </el-table-column>
            <el-table-column
                    prop="description"
                    label="描述">
            </el-table-column>
            <el-table-column prop="submitTime" label="申请时间"> </el-table-column>
            <el-table-column prop="userList[0].name" label="上节点提交人">
            </el-table-column>
            <el-table-column prop="dealTime" label="上节点提交时间">
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <span class="status" :class=[$reconava.getStatusClass(scope.row.status)]>
                  {{$reconava.getStatusName(scope.row.status) }}</span>
              </template>
            </el-table-column>
            <el-table-column width="100" label="操作">
              <template slot-scope="scope">
                <span @click="see(scope.row,false,true)" class="blue">查看</span>
              </template>
            </el-table-column>
          </el-table>
          <ReconovaPagination
            v-if="tableData.length > 0"
            @paginationChange="paginationChange"
            :page-no="search.pageNum"
            :page-size="search.pageSize"
            :total="total"
          >
          </ReconovaPagination>
        </div>

      </div>
    </template>

    <template v-else-if="viewType === 'see'">
      <check-detail @cancel="cancel" :id="currentId" type="see" from="copyToMe"></check-detail>
    </template>

    <template v-else-if="viewType === 'approvalDetail'">
      <approval-detail @changeType="close" type="bcc" :id="currentId"></approval-detail>
    </template>

    <template v-else-if="viewType === 'flowDetail'">
      <flow-detail @changeType="close" type="bcc" :id="currentId"></flow-detail>
    </template>

    <template v-else-if="viewType === 'contractDetail'">
      <labor-contract-detail @changeType="close" :id="currentId" from="copyToMe"></labor-contract-detail>
    </template>

    <template v-else-if="viewType === 'positiveDetail'">
      <positive-detail @changeType="close" :id="currentId" from="copyToMe"></positive-detail>
    </template>

    <template
      v-else-if="['dynamicFormDetail', 'dynamicFormEdit'].includes(viewType)"
    >
      <dynamic-form-wrapper
        :id="currentId"
        :viewType="viewType"
        @changeType="close"
      ></dynamic-form-wrapper>
    </template>
  </div>
</template>

<script>
import SearchBox from "./searchBox";
import ReconovaPagination from "@/components/reconova/reconovaPagination";
import mixins from "./components/mixins";
import {sendList} from "../../../services/checkModule";
import LaborContractDetail from "../../businessModule/personnel/labor-contract/detail";
import PositiveDetail from "../../businessModule/personnel/positive/detail";
import CheckDetail from "../../businessModule/examine/formDetail/checkDetail";
import DynamicFormWrapper from "./components/dynamicFormWrapper.vue";
export default {
  name: "bcc",
  components: {CheckDetail, PositiveDetail, LaborContractDetail, ReconovaPagination, SearchBox, DynamicFormWrapper },
  mixins: [ mixins ],
  data() {
    let enterpriseCode = JSON.parse(localStorage.getItem("userInfo"))
      .enterpriseCode;
    return {
      currentId:'',//数据编号
      viewType: "list",
      statusList:[
        { label: "全部", value: "" },
        { label: "未读", value: "0" },
        { label: "已读", value: "1" },
      ],
      search: {
        pageNum: 1,
        pageSize: 20,
        handleStatus: "",
        typeId: "",
        enterpriseCode: enterpriseCode,
      },
      tableData: [],
      total: 0
    };
  },
  methods: {
    cancel() {
      this.viewType = "list";
      this.$nextTick(()=>{
        this.getData();
      })
    },

    research() {
      this.search.pageNum = 1;
      this.getData();
    },

    //获取列表数据
    getData() {
      let search = Object.assign(this.search, this.$refs.search.getQuery());
      search.keyList =
        (search.keyList && search.keyList.join && search.keyList.join(",")) ||
        "";
      sendList(search).then((res) => {
        this.tableData = res.data.list.map(item => {
          return {
            ...item,
            description: item.content ? item.content.description : '',
          }
        });
        this.total = res.data.total;
      });
    },
    //翻页
    paginationChange(type, val) {
      if (type === "pageNo") {
        this.search.pageNum = val;
      } else {
        this.search.pageNum = 1;
        this.search.pageSize = val;
      }
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
@import "css/examine.scss";
</style>
